import { useEffect, useState } from 'react';

/**
 * Generischer Debounce fuer einen Eingabewert.
 *
 * Ergaenzt useDebouncedDateRange (Dashboard-Zeitraum, mit
 * Gueltigkeitspruefung) um den einfachen Fall "Wert verzoegert
 * uebernehmen" — z. B. das Suchfeld der Benutzerliste, das sonst pro
 * Tastendruck einen Listen-Request ausloesen wuerde.
 *
 * Der zurueckgegebene Wert folgt dem Eingabewert erst, wenn `delayMs`
 * lang keine Aenderung mehr kam. Beim Unmount bzw. bei jeder Aenderung
 * wird der laufende Timer verworfen.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handle = window.setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);
    return () => {
      window.clearTimeout(handle);
    };
  }, [value, delayMs]);

  return debouncedValue;
}

export default useDebouncedValue;
